"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _basePlaylist = _interopRequireDefault(require("./base-playlist"));

var _playlistParser = require("../parsers/playlist/playlist-parser");

var _transportStream = _interopRequireDefault(require("../parsers/container/ts/transport-stream"));

var _elementaryStream = _interopRequireDefault(require("../parsers/container/ts/elementary-stream"));

var _transmuxer = _interopRequireDefault(require("../transmuxing/transmuxer"));

var _types = _interopRequireDefault(require("../types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function set(target, property, value, receiver) { if (typeof Reflect !== "undefined" && Reflect.set) { set = Reflect.set; } else { set = function set(target, property, value, receiver) { var base = _superPropBase(target, property); var desc; if (base) { desc = Object.getOwnPropertyDescriptor(base, property); if (desc.set) { desc.set.call(receiver, value); return true; } else if (!desc.writable) { return false; } } desc = Object.getOwnPropertyDescriptor(receiver, property); if (desc) { if (!desc.writable) { return false; } desc.value = value; Object.defineProperty(receiver, property, desc); } else { _defineProperty(receiver, property, value); } return true; }; } return set(target, property, value, receiver); }

function _set(target, property, value, receiver, isStrict) { var s = set(target, property, value, receiver || target); if (!s && isStrict) { throw new Error('failed to set property'); } return value; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/**
 * A Media Playlist contains a list of Media Segments, which when played
   sequentially will play the multimedia presentation.

   Here is an example of a Media Playlist:

   #EXTM3U
   #EXT-X-TARGETDURATION:10

   #EXTINF:9.009,
   http://media.example.com/first.ts
   #EXTINF:9.009,
   http://media.example.com/second.ts
   #EXTINF:3.003,
   http://media.example.com/third.ts
 */
var MediaPlaylist =
/*#__PURE__*/
function (_Playlist) {
  _inherits(MediaPlaylist, _Playlist);

  function MediaPlaylist(playlistStruct, body, startIdx) {
    var _this;

    _classCallCheck(this, MediaPlaylist);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MediaPlaylist).call(this, playlistStruct, body));
    _this._ended = false;
    _this.segments = [];
    _this.objType = 'MediaPlaylist';
    (0, _playlistParser.configureMediaPlaylist)(_assertThisInitialized(_assertThisInitialized(_this)), playlistStruct, startIdx);
    return _this;
  }

  _createClass(MediaPlaylist, [{
    key: "startAutoRefresh",
    value: function startAutoRefresh(onRefresh) {
      this.onRefresh = onRefresh;
      this.refresh = this.refresh.bind(this);
      this.refreshTimer = setInterval(this.refresh, this.refreshInterval);
    }
  }, {
    key: "stopAutoRefresh",
    value: function stopAutoRefresh() {
      clearInterval(this.refreshTimer);
      delete this['refreshTimer'];
    }
    /**
     * get ended - A bool marking if the stream is ended/complete (VOD playlists / Complete EVENT playlists)
     *
     * @return {bool} true if the playlist is complete
     */

  }, {
    key: "refresh",
    //  The peak segment bit rate of a Media Playlist is the largest bit rate
    // of any contiguous set of segments whose total duration is between 0.5
    // and 1.5 times the target duration.  The bit rate of a set is
    // calculated by dividing the sum of the segment sizes by the sum of the
    // segment durations.
    // get peakBitRate() {
    //   return undefined
    // }
    // The average segment bit rate of a Media Playlist is the sum of the
    //   sizes (in bits) of every Media Segment in the Media Playlist, divided
    //   by the Media Playlist duration.  Note that this includes container
    //   overhead, but not HTTP or other overhead imposed by the delivery
    //   system.
    // get avgBitRate() {
    //   return undefined
    // }

    /**
     * refresh - Refetch the playlist and update all relevant values
     *
     * @return {Promise<Playlist>} Will return a reference to the current playlist (mutated)
     */
    value: function refresh() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        if (_this2.type != 'LIVE' && _this2.type != 'EVENT' || _this2.ended) {
          reject("Can't refresh playlist");
        }

        _basePlaylist.default.fetch(_this2.url).then(function (refreshedPlaylist) {
          var segmentBump = _this2.type === 'LIVE' ? true : false;

          _this2.updateSegments(refreshedPlaylist.segments, segmentBump);

          _this2.ended = refreshedPlaylist.ended;
          _this2.mediaSequenceNumber = refreshedPlaylist.mediaSequenceNumber;

          if (_this2.onRefresh) {
            _this2.onRefresh(_this2);
          }

          resolve(_this2);
        }).catch(function (err) {
          return reject(err);
        });
      }).catch(function (err) {
        _this2.refresh();
      });
    }
    /**
     * getCodecsInformation - If no codec information is attached to the playlist this will
     * either download the first segment and attempt to determine what it is.
     * In playlists that contain fragmented mp4's this is an init segment which is typically about 1.4k in size
     * In playlists that contain transport streams, this is usually a full media segment
     *
     * @return {Promise<Object>} Returns a promise the resolves to an object containing codec information
     */

  }, {
    key: "getCodecsInformation",
    value: function getCodecsInformation() {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        if (_this3.codecs) {
          resolve(_this3.codecs);
        }

        if (!_this3.segments) {
          reject('No segments in playlist');
        }

        if (_this3.segments.length <= 0) {
          reject('No segments in playlist');
        }

        var initSegments = _this3.segments.filter(function (s) {
          return s.objType === _types.default.MediaInitializationSegment;
        });

        if (initSegments.length > 0) {
          var initSegment = initSegments[0];
          initSegment.fetch().then(function (s) {
            _this3.codecs = initSegment.codecs.codecs;
            _this3.codecsString = initSegment.codecs.codecsString;
            resolve(initSegment.codecs.codecs);
          }).catch(function (err) {
            reject(err);
          });
          return;
        } else {
          if (_this3.segments.count <= 0) {
            reject('Playlist had no segments.');
          }

          var firstSegment = _this3.segments[0];
          firstSegment.fetch().then(function (s) {
            var ts = _transportStream.default.parse(s);

            _this3.codecs = ts.trackPackets.map(function (tp) {
              return tp.codec;
            });
            _this3.codecsString = ts.codecsString;
            resolve(_this3.codecs);
          }).catch(function (err) {
            reject(err);
          });
        }
      });
    }
  }, {
    key: "updateSegments",

    /**
     * updateSegments - Used by refresh to only replace entries in the segment array that have changed.
     * This prevents data from being blown away whenever we're interacting with live or event placelists
     * VOD playlists can just use the setter
     *
     * @param  {Array<Segment>} segments An array of segments
     */
    value: function updateSegments(segments, segmentBump) {
      var results = [];
      var startsWithInitSegment = false;
      var lastOldSegmentID;

      for (var i = 0; i < segments.length; i++) {
        var oldSegment = this.segments[i];
        var newSegment = segments[i];

        if (i == 0) {
          if (oldSegment.objType === _types.default.MediaSegment && newSegment.objType === _types.default.MediaSegment) {
            startsWithInitSegment = false;
            oldSegment = this.segments[i + 1];
          } else {
            startsWithInitSegment = true;
          }
        }

        if (this.type == 'LIVE') {
          if (i > 0) {
            oldSegment = this.segments[i + 1];
          }
        }

        if (oldSegment) {
          lastOldSegmentID = oldSegment.id;

          if (newSegment.uri == oldSegment.uri) {
            results.push(oldSegment);
          } else {
            results.push(newSegment);
          }
        } else {
          newSegment.id = lastOldSegmentID + 1;
          results.push(newSegment);
        }
      }

      this.segments = results;
    }
  }, {
    key: "basePath",
    set: function set(val) {
      _set(_getPrototypeOf(MediaPlaylist.prototype), "basePath", val, this, true);

      this.segments.forEach(function (segment) {
        return segment.basePath = val;
      });
    },
    get: function get() {
      return this._basePath;
    }
    /**
     * get type - The type of playlist (VOD, EVENT, LIVE)
     *
     * @return {String}  String describing the type of playlist
     */

  }, {
    key: "type",
    get: function get() {
      if (this._type) {
        return this._type;
      }

      if (!this.ended) {
        return 'LIVE';
      }
    }
    /**
     * get totalDuration - The duration of all segments in the playlist
     *
     * @return {Float} Number of seconds of all durations in the playlist
     */

  }, {
    key: "totalDuration",
    get: function get() {
      return this.segments.filter(function (segment) {
        return segment.objType === _types.default.MediaSegment;
      }).reduce(function (acc, curr) {
        return acc + curr.duration;
      }, 0);
    }
    /**
     * get avgDuration - Averate duration across all segments
     *
     * @return {Float} The average of all the segments in the playlist
     */

  }, {
    key: "avgDuration",
    get: function get() {
      return this.totalDuration / this.segments.length;
    }
    /**
     * get refreshInterval - The rate at which we will auto-refresh a playlist
     *
     * @return {Integer} Number of miliseconds to wait between auto refresh requests
     */

  }, {
    key: "refreshInterval",
    get: function get() {
      // It MUST be made available relative to the time that the previous version of the Playlist file
      // was made available: no earlier than one-half the target duration
      // after that time, and no later than 1.5 times the target duration
      // after that time.
      // TODO: possibly use cache/etags to handle this better?
      if (this.avgDuration < this.targetDuration / 2 || this.avgDuration > this.targetDuration * 1.5) {
        return this.targetDuration * 1000;
      }

      return this.avgDuration * 1000;
    }
  }, {
    key: "ended",
    get: function get() {
      return this._ended;
    },
    set: function set(val) {
      this._ended = val; // If we have ended and there is a timer, clear it.

      if (this._ended && this.refreshTimer) {
        this.stopAutoRefresh();
      }
    }
  }, {
    key: "segmentsType",
    get: function get() {
      var initSegments = this.segments.filter(function (s) {
        return s.objType === _types.default.MediaInitializationSegment;
      });

      if (initSegments.length > 0) {
        return 'fmp4';
      } else {
        return 'ts';
      }
    }
  }]);

  return MediaPlaylist;
}(_basePlaylist.default);

var _default = MediaPlaylist;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@krad/plainview/node_modules/@krad/slugline/distribution/playlists/media-playlist.js
// module id = 471
// module chunks = 0